import { render, staticRenderFns } from "./MissingAttachmentsModal.vue?vue&type=template&id=f45d56ee&scoped=true&"
import script from "./MissingAttachmentsModal.vue?vue&type=script&lang=js&"
export * from "./MissingAttachmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./MissingAttachmentsModal.vue?vue&type=style&index=0&id=f45d56ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45d56ee",
  null
  
)

export default component.exports